import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { formatDateTime } from "@/utils/formatting";

// Define the structure based on change_log table
type ChangeLogEntry = {
  id: number;
  version_id: number;
  provider_id: number;
  region_id: number;
  entity_type: string;
  entity_id: number;
  field_name: string;
  action_type: 'CREATE' | 'UPDATE' | 'DELETE';
  old_value: string | null;
  new_value: string | null;
  created_at: string;
  updated_at: string;
};

interface AllChangesTableProps {
  changes?: ChangeLogEntry[];
  isLoading: boolean;
}

const statusColors = {
  CREATE: "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-100",
  UPDATE: "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-100",
  DELETE: "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-100"
};

export function AllChangesTable({ changes = [], isLoading }: AllChangesTableProps) {
  if (isLoading) return <div>Loading...</div>;

  // Filter out is_duplicate and is_local fields
  const filteredChanges = changes.filter(change =>
    change.field_name !== 'is_duplicate' && change.field_name !== 'is_local'
  );

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Entity</TableHead>
          <TableHead>Field</TableHead>
          <TableHead>Action</TableHead>
          <TableHead>Old Value</TableHead>
          <TableHead>New Value</TableHead>
          <TableHead>Timestamp</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {filteredChanges.map((change) => (
          <TableRow key={change.id}>
            <TableCell>
              <Badge variant="outline" className="capitalize">
                {change.entity_type} #{change.entity_id}
              </Badge>
            </TableCell>
            <TableCell className="font-medium">{change.field_name}</TableCell>
            <TableCell>
              <Badge className={statusColors[change.action_type]}>
                {change.action_type}
              </Badge>
            </TableCell>
            <TableCell>
              <div className="text-xs text-muted-foreground">
                {change.old_value || '-'}
              </div>
            </TableCell>
            <TableCell>
              <div className="text-xs font-medium">
                {change.new_value || '-'}
              </div>
            </TableCell>
            <TableCell>
              <div className="text-xs">{formatDateTime(change.created_at)}</div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}